exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-module-form .module-form-emoji-wrapper{margin-bottom:1rem;text-align:center}.fts-module-form .module-form-emoji-wrapper .module-form-emoji{display:inline-flex}.fts-module-form .module-form-description{margin-top:1rem;font-size:.875rem;color:var(--fts-default)}.fts-module-form .module-form-event-container{margin:-0.375rem 0 0 -0.375rem;display:flex;flex-wrap:wrap}.fts-module-form .module-form-event-container>*{margin:.375rem 0 0 .375rem}", ""]);

// exports
